<template>
  <div :class="[{ 'nav-open': $sidebar.showSidebar }]" class="wrapper">
    <notifications />

    <side-bar :active-color="sidebarBackground" :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor">
      <!-- <user-menu /> -->
      <!-- <mobile-menu /> -->

      <template slot="links">
        <sidebar-item class="user-profile-item" style="padding-bottom: 1rem;"
          :link="{ name: title, icon: 'person_outline', path: '/portal/technician' }">
          <sidebar-item :link="{ name: 'My Settings', icon: 'settings', path: '/portal/technician/my-settings' }" />
        </sidebar-item>
        <span class="user-role">Technician</span>
        <div style="border-bottom: solid 1px rgba(180, 180, 180, .3);margin-left: 1rem;margin-right: 1rem;"></div>

        <!--        <sidebar-item :link="{ name: 'My Dashboard', icon: 'home', path: '/portal/technician/dashboard' }" /> -->

        <!--        <sidebar-item :link="{ name: 'My Messages', icon: 'mail_outline', path: '/portal/technician/messages' }" /> -->

        <p align="Left" class="menu-item-title">READING CENTER</p>

        <!--PACKAGES-->
        <sidebar-item :link="{ name: 'Packages', icon: 'cloud_upload', path: '/portal/technician/packages' }" />

        <!--SCREENINGS-->
        <sidebar-item :link="{ name: 'Screenings', icon: 'visibility', path: '/portal/technician' }">
          <sidebar-item :link="{ name: 'Available', icon: 'dashboard', path: '/portal/technician/screenings' }" />
          <sidebar-item :link="{ name: 'On-Hold', icon: 'dashboard', path: '/portal/technician/Onhold' }" />
        </sidebar-item>

        <!--PATIENTS-->
        <sidebar-item :link="{ name: 'Patients', icon: 'person', path: '/portal/technician/patients' }" />

        <!-- BILLING -->
        <sidebar-item :link="{
          name: 'Billing',
          icon: 'attach_money',
          path: '/portal/technician/billing'
        }" />

        <!--SiView-->
        <sidebar-item :link="{ name: 'SiView', icon: 'history', path: '/portal/technician/siview' }" />

        <!--REPORTS-->
        <sidebar-item :link="{ name: 'Reports', icon: 'assignment_ind', path: '/portal/technician/reports' }" />

        <!-- <p align="Left" style="font-size: .7rem; color: #777; font-weight: 400; margin-left:10px;">ADMINISTRATIVE</p> -->

        <!-- <sidebar-item :link="{ name: 'Settings', icon: 'settings', path: '/portal/technician/' }" /> -->
      </template>
    </side-bar>

    <div class="main-panel">
      <top-navbar class="top-navbar" />

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view style="margin-top: 50px;" align="Center" />
        </zoom-center-transition>
      </div>

      <content-footer v-if="!$route.meta.hideFooter" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar"
import "perfect-scrollbar/css/perfect-scrollbar.css"

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

import TopNavbar from "./TopNavbar.vue"
import ContentFooter from "./ContentFooter.vue"
import MobileMenu from "./Extra/MobileMenu.vue"
//import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue"
import { ZoomCenterTransition } from "vue2-transitions"

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    //FixedPlugin,
    UserMenu,
    ZoomCenterTransition
  },
  props: {
    title: {
      type: String,
      default: sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
    }
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "", //"./img/sidebar-0.jpg"
      sidebarMini: false,
      sidebarImg: true
    }
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar()
    }
  },
  mounted() {
    let docClasses = document.body.classList
    let isWindows = navigator.platform.startsWith("Win")
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar")
      initScrollbar("sidebar-wrapper")
      initScrollbar("main-panel")

      docClasses.add("perfect-scrollbar-on")
    } else {
      docClasses.add("perfect-scrollbar-off")
    }
    this.maximixeSidebar()
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    maximixeSidebar() {
      this.$sidebar.toggleMinimize()
    }
  }
}
</script>

<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
